var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodingAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 1000 1000",
    style: {
      width: "100%",
      height: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_14_G",
    fill: "freeze",
    attributeName: "transform",
    from: 0,
    to: 0,
    type: "rotate",
    additive: "sum",
    keyTimes: "0;0.0367647;0.0735294;0.1102941;0.1470588;0.1838235;0.2205882;0.2573529;0.2941176;0.3308823;0.367647;0.4044117;0.4411765;0.4779412;0.5147059;0.5514706;0.5882353;0.625;0.6617647;0.6985294;0.7352941;0.7720588;0.8088235;0.8455882;0.8823529;1",
    values: "0;2;0;2;0;2;0;2;0;2;0;2;0;2;0;2;0;2;0;2;0;2;0;2;0;0",
    keySplines: "0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_14_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-568 -612",
    to: "-568 -612",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-568 -612;-568 -612",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_13_G",
    fill: "freeze",
    attributeName: "transform",
    from: 0,
    to: 0,
    type: "rotate",
    additive: "sum",
    keyTimes: "0;0.0367647;0.0735294;0.1102941;0.1470588;0.1838235;0.2205882;0.2573529;0.2941176;0.3308823;0.367647;0.4044117;0.4411765;0.4779412;0.5147059;0.5514706;0.5882353;0.625;0.6617647;0.6985294;0.7352941;0.7720588;0.8088235;0.8455882;0.8823529;1",
    values: "0;5;0;5;0;5;0;5;0;5;0;5;0;5;0;5;0;5;0;5;0;5;0;5;0;0",
    keySplines: "0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_13_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-388 -934",
    to: "-388 -934",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-388 -934;-388 -934",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_12_C_0_P_0",
    fill: "freeze",
    attributeName: "d",
    attributeType: "XML",
    from: "M-1.81 178.27 C-1.81,178.27 -1.81,248.94 -1.81,248.94 C-1.81,248.94 112.01,248.94 112.01,248.94 C112.01,248.94 112.01,178.27 112.01,178.27 C112.01,178.27 -1.81,178.27 -1.81,178.27z ",
    to: "M128.19 244.27 C128.19,244.27 128.19,314.94 128.19,314.94 C128.19,314.94 242.01,314.94 242.01,314.94 C242.01,314.94 242.01,244.27 242.01,244.27 C242.01,244.27 128.19,244.27 128.19,244.27z ",
    keyTimes: "0;0.2205882;0.2941176;1",
    values: "M-1.81 178.27 C-1.81,178.27 -1.81,248.94 -1.81,248.94 C-1.81,248.94 112.01,248.94 112.01,248.94 C112.01,248.94 112.01,178.27 112.01,178.27 C112.01,178.27 -1.81,178.27 -1.81,178.27z ;M-1.81 178.27 C-1.81,178.27 -1.81,248.94 -1.81,248.94 C-1.81,248.94 112.01,248.94 112.01,248.94 C112.01,248.94 112.01,178.27 112.01,178.27 C112.01,178.27 -1.81,178.27 -1.81,178.27z ;M128.19 244.27 C128.19,244.27 128.19,314.94 128.19,314.94 C128.19,314.94 242.01,314.94 242.01,314.94 C242.01,314.94 242.01,244.27 242.01,244.27 C242.01,244.27 128.19,244.27 128.19,244.27z ;M128.19 244.27 C128.19,244.27 128.19,314.94 128.19,314.94 C128.19,314.94 242.01,314.94 242.01,314.94 C242.01,314.94 242.01,244.27 242.01,244.27 C242.01,244.27 128.19,244.27 128.19,244.27z ",
    keySplines: "0.167 0 0.667 1;0.167 0 0.667 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "_R_G_L_12_C_0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_12_C_0_P_0",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_11_C_0_P_0",
    fill: "freeze",
    attributeName: "d",
    attributeType: "XML",
    from: "M494.11 266.89 C494.11,266.89 494.11,337.56 494.11,337.56 C494.11,337.56 701.36,337.56 701.36,337.56 C701.36,337.56 701.36,266.89 701.36,266.89 C701.36,266.89 494.11,266.89 494.11,266.89z ",
    to: "M724.11 350.89 C724.11,350.89 724.11,421.56 724.11,421.56 C724.11,421.56 931.36,421.56 931.36,421.56 C931.36,421.56 931.36,350.89 931.36,350.89 C931.36,350.89 724.11,350.89 724.11,350.89z ",
    keyTimes: "0;0.2941176;0.3676471;1",
    values: "M494.11 266.89 C494.11,266.89 494.11,337.56 494.11,337.56 C494.11,337.56 701.36,337.56 701.36,337.56 C701.36,337.56 701.36,266.89 701.36,266.89 C701.36,266.89 494.11,266.89 494.11,266.89z ;M494.11 266.89 C494.11,266.89 494.11,337.56 494.11,337.56 C494.11,337.56 701.36,337.56 701.36,337.56 C701.36,337.56 701.36,266.89 701.36,266.89 C701.36,266.89 494.11,266.89 494.11,266.89z ;M724.11 350.89 C724.11,350.89 724.11,421.56 724.11,421.56 C724.11,421.56 931.36,421.56 931.36,421.56 C931.36,421.56 931.36,350.89 931.36,350.89 C931.36,350.89 724.11,350.89 724.11,350.89z ;M724.11 350.89 C724.11,350.89 724.11,421.56 724.11,421.56 C724.11,421.56 931.36,421.56 931.36,421.56 C931.36,421.56 931.36,350.89 931.36,350.89 C931.36,350.89 724.11,350.89 724.11,350.89z ",
    keySplines: "0.167 0 0.667 1;0.167 0 0.667 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "_R_G_L_11_C_0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_11_C_0_P_0",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_10_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.4411765;0.4779412;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.667 1;0.167 0.167 0.667 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_10_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-343.305 -327.697",
    to: "-343.305 -327.697",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-343.305 -327.697;-343.305 -327.697",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_9_G",
    fill: "freeze",
    attributeName: "transform",
    from: 0,
    to: 360,
    type: "rotate",
    additive: "sum",
    keyTimes: "0;0.5147059;0.8823529;1",
    values: "0;0;360;360",
    keySplines: "0.167 0.167 0.667 1;0.167 0.167 0.667 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_9_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.4779412;0.5147059;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.667 1;0.167 0.167 0.667 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_9_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-343.305 -327.697",
    to: "-343.305 -327.697",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-343.305 -327.697;-343.305 -327.697",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_8_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.0735294;0.1102941;1",
    values: "0 0;1.1 1.1;1 1;1 1",
    keySplines: "0.167 0.167 0.833 0.833;0.167 0.167 0.667 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_8_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-392 -526",
    to: "-392 -526",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-392 -526;-392 -526",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_7_C_0_P_0",
    fill: "freeze",
    attributeName: "d",
    attributeType: "XML",
    from: "M405.1 222.54 C405.1,222.54 405.1,340.34 405.1,340.34 C405.1,340.34 651.14,340.34 651.14,340.34 C651.14,340.34 651.14,222.54 651.14,222.54 C651.14,222.54 405.1,222.54 405.1,222.54z ",
    to: "M405.55 354.54 C405.55,354.54 405.55,472.34 405.55,472.34 C405.55,472.34 651.59,472.34 651.59,472.34 C651.59,472.34 651.59,354.54 651.59,354.54 C651.59,354.54 405.55,354.54 405.55,354.54z ",
    keyTimes: "0;0.1102941;0.2205882;1",
    values: "M405.1 222.54 C405.1,222.54 405.1,340.34 405.1,340.34 C405.1,340.34 651.14,340.34 651.14,340.34 C651.14,340.34 651.14,222.54 651.14,222.54 C651.14,222.54 405.1,222.54 405.1,222.54z ;M405.1 222.54 C405.1,222.54 405.1,340.34 405.1,340.34 C405.1,340.34 651.14,340.34 651.14,340.34 C651.14,340.34 651.14,222.54 651.14,222.54 C651.14,222.54 405.1,222.54 405.1,222.54z ;M405.55 354.54 C405.55,354.54 405.55,472.34 405.55,472.34 C405.55,472.34 651.59,472.34 651.59,472.34 C651.59,472.34 651.59,354.54 651.59,354.54 C651.59,354.54 405.55,354.54 405.55,354.54z ;M405.55 354.54 C405.55,354.54 405.55,472.34 405.55,472.34 C405.55,472.34 651.59,472.34 651.59,472.34 C651.59,472.34 651.59,354.54 651.59,354.54 C651.59,354.54 405.55,354.54 405.55,354.54z ",
    keySplines: "0.167 0 0.667 1;0.167 0 0.667 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "_R_G_L_7_C_0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_7_C_0_P_0",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_3_G",
    fill: "freeze",
    attributeName: "transform",
    from: 0,
    to: 360,
    type: "rotate",
    additive: "sum",
    keyTimes: "0;0.4411765;0.8823529;1",
    values: "0;0;360;360",
    keySplines: "0.167 0.167 0.667 1;0.167 0.167 0.667 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_3_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.367647;0.4044117;0.4411765;1",
    values: "0 0;0 0;1.1 1.1;1 1;1 1",
    keySplines: "0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.667 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_3_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-650.444 -274.732",
    to: "-650.444 -274.732",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-650.444 -274.732;-650.444 -274.732",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_2_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.5147059;0.5882353;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.667 1;0.167 0.167 0.667 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_2_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-500 -500",
    to: "-500 -500",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-500 -500;-500 -500",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_1_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.6617647;0.7352941;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.667 1;0.167 0.167 0.667 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_1_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-536 -450",
    to: "-536 -450",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-536 -450;-536 -450",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G",
    fill: "freeze",
    attributeName: "transform",
    from: "0 0",
    to: "1 1",
    type: "scale",
    additive: "sum",
    keyTimes: "0;0.5882353;0.6617647;1",
    values: "0 0;0 0;1 1;1 1",
    keySplines: "0.167 0.167 0.667 1;0.167 0.167 0.667 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "4.5378712s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-500 -466",
    to: "-500 -466",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-500 -466;-500 -466",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "opacity",
    dur: "5s",
    from: 0,
    to: 1,
    xlinkHref: "#time_group"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_R_G"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_15_G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_0_P_0",
    fill: "#fff3d5",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M931.36 466.65 C870.09,558.38 739.35,842.07 771.51,947.36 C771.51,947.36 302.48,947.46 302.48,947.46 C302.48,947.46 234.7,897 168.86,809.27 C156.89,793.33 144.99,776.14 133.58,757.82 C121.47,738.4 109.91,717.69 99.41,695.78 C68.88,632.24 47.1,558.6 46.22,477.2 C43.14,195.44 287.01,-66.42 618.75,39.25 C950.5,144.92 992.61,374.92 931.36,466.65z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_1_P_0",
    fill: "#ec1800",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M637.89 950.68 C636.95,950.68 636.02,950.27 635.38,949.48 C635.38,949.48 385.25,638.47 385.25,638.47 C384.13,637.09 384.35,635.06 385.74,633.94 C387.13,632.83 389.15,633.05 390.27,634.43 C390.27,634.43 640.4,945.43 640.4,945.43 C641.52,946.82 641.3,948.85 639.91,949.97 C639.32,950.44 638.6,950.68 637.89,950.68z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_2_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M249.89 950.68 C249.18,950.68 248.47,950.44 247.87,949.97 C246.49,948.85 246.27,946.82 247.38,945.43 C247.38,945.43 497.51,634.43 497.51,634.43 C498.63,633.05 500.66,632.83 502.04,633.94 C503.43,635.06 503.65,637.09 502.53,638.47 C502.53,638.47 252.4,949.48 252.4,949.48 C251.77,950.27 250.83,950.68 249.89,950.68z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_3_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M500.03 950.68 C499.08,950.68 498.15,950.27 497.51,949.48 C497.51,949.48 247.38,638.47 247.38,638.47 C246.27,637.09 246.49,635.06 247.87,633.94 C249.26,632.83 251.29,633.05 252.4,634.43 C252.4,634.43 502.53,945.43 502.53,945.43 C503.65,946.82 503.43,948.85 502.04,949.97 C501.45,950.44 500.73,950.68 500.03,950.68z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_4_P_0",
    fill: "#ec1800",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M294.21 644.71 C294.21,644.71 178,644.71 178,644.71 C173.45,644.71 169.75,641.01 169.75,636.45 C169.75,631.89 173.45,628.2 178,628.2 C178,628.2 294.21,628.2 294.21,628.2 C298.77,628.2 302.47,631.89 302.47,636.45 C302.47,641.01 298.77,644.71 294.21,644.71z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_5_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M628.57 644.71 C628.57,644.71 296.43,644.71 296.43,644.71 C291.87,644.71 288.17,641.01 288.17,636.45 C288.17,631.89 291.87,628.2 296.43,628.2 C296.43,628.2 628.57,628.2 628.57,628.2 C628.57,628.2 628.57,644.71 628.57,644.71z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_6_P_0",
    fill: "#ec1800",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M383.98 791.95 C383.98,796.94 379.94,800.97 374.96,800.97 C369.98,800.97 365.94,796.94 365.94,791.95 C365.94,786.97 369.98,782.94 374.96,782.94 C379.94,782.94 383.98,786.97 383.98,791.95z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_7_P_0",
    fill: "#ffc828",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M521.84 791.95 C521.84,796.94 517.8,800.97 512.82,800.97 C507.84,800.97 503.8,796.94 503.8,791.95 C503.8,786.97 507.84,782.94 512.82,782.94 C517.8,782.94 521.84,786.97 521.84,791.95z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_8_P_0",
    fill: "#a2b4ad",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M343.31 546.9 C343.31,546.9 446.35,546.9 446.35,546.9 C446.35,546.9 483.62,618.62 483.62,618.62 C483.62,618.62 380.57,618.62 380.57,618.62 C380.57,618.62 343.31,546.9 343.31,546.9z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_9_P_0",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M382.66 613.32 C382.66,613.32 351.8,553.93 351.8,553.93 C351.15,552.69 352.06,551.2 353.46,551.2 C353.46,551.2 442.61,551.2 442.61,551.2 C443.31,551.2 443.95,551.59 444.27,552.21 C444.27,552.21 475.12,611.59 475.12,611.59 C475.77,612.84 474.87,614.33 473.46,614.33 C473.46,614.33 384.32,614.33 384.32,614.33 C383.62,614.33 382.98,613.94 382.66,613.32z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_10_P_0",
    fill: "#88938f",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M464.03 618.62 C464.03,618.62 380.57,618.62 380.57,618.62 C380.57,618.62 380.57,628.2 380.57,628.2 C380.57,628.2 464.03,628.2 464.03,628.2 C464.03,628.2 464.03,618.62 464.03,618.62z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_11_P_0",
    fill: "#a3b3ad",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M535.73 618.62 C535.73,618.62 453.38,618.62 453.38,618.62 C450.73,618.62 448.59,620.77 448.59,623.41 C448.59,626.05 450.73,628.2 453.38,628.2 C453.38,628.2 535.73,628.2 535.73,628.2 C538.38,628.2 540.52,626.05 540.52,623.41 C540.52,620.77 538.38,618.62 535.73,618.62z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_12_P_0",
    fill: "#b5c5bf",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M380.57 618.62 C380.57,618.62 343.3,546.9 343.3,546.9 C343.3,546.9 341.44,548.31 341.44,548.31 C340.23,549.21 339.86,550.86 340.56,552.19 C340.56,552.19 380.57,628.2 380.57,628.2 C380.57,628.2 380.57,618.62 380.57,618.62z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_13_P_0",
    fill: "#9fccb7",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M418.09 624.69 C418.09,624.69 408.9,624.69 408.9,624.69 C408.9,624.69 408.9,623.09 408.9,623.09 C408.9,623.09 418.09,623.09 418.09,623.09 C418.09,623.09 418.09,624.69 418.09,624.69z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_14_P_0",
    fill: "#9fccb7",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M429.64 624.69 C429.64,624.69 420.45,624.69 420.45,624.69 C420.45,624.69 420.45,623.09 420.45,623.09 C420.45,623.09 429.64,623.09 429.64,623.09 C429.64,623.09 429.64,624.69 429.64,624.69z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_15_P_0",
    fill: "#9fccb7",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M441.19 624.69 C441.19,624.69 432,624.69 432,624.69 C432,624.69 432,623.09 432,623.09 C432,623.09 441.19,623.09 441.19,623.09 C441.19,623.09 441.19,624.69 441.19,624.69z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_16_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M248.17 564.48 C248.13,567.28 247.87,569.92 247.35,572.26 C247.35,572.26 222.71,572.26 222.71,572.26 C215.47,567.45 203.66,557.93 196.57,543.64 C203.16,550.82 214.42,559.56 225.89,562.23 C235.9,564.55 243.36,563.56 248.17,564.48z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_17_P_0",
    fill: "#51b9a6",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M305.4 466.65 C302.65,476.64 290.04,496.02 278.52,516.77 C265.93,539.41 254.68,563.67 259.08,579.07 C260.18,582.93 260.67,585.77 260.67,587.81 C260.71,594.51 255.62,592.43 250.49,588.63 C245.25,584.74 239.94,579.07 239.94,579.07 C239.94,579.07 240.33,549.21 240.33,549.21 C240.33,549.21 223.4,533.66 237.3,499.63 C238.18,497.48 239.19,495.25 240.33,492.93 C259.47,454.26 288.17,413.68 260.99,402.19 C298.52,399.89 311.15,445.75 305.4,466.65z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_18_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M260.99 402.19 C260.99,402.19 261.66,402.3 262.86,402.66 C264.06,403.03 265.8,403.7 267.85,404.85 C269.91,405.98 272.25,407.67 274.5,410.07 C276.74,412.45 278.88,415.51 280.56,419.19 C282.16,422.9 283.33,427.14 284,431.71 C284.36,434 284.23,436.42 283.94,438.82 C283.63,441.23 283.09,443.66 282.43,446.09 C281.11,450.96 279.31,455.86 277.31,460.76 C275.32,465.66 273.12,470.57 270.86,475.44 C266.33,485.19 261.57,494.81 257.31,503.93 C253.04,513.05 249.27,521.66 246.63,529.26 C245.31,533.05 244.25,536.58 243.56,539.76 C242.84,542.94 242.48,545.76 242.43,548.07 C242.36,550.39 242.6,552.2 242.87,553.4 C242.99,554 243.14,554.45 243.24,554.75 C243.33,555.05 243.38,555.2 243.38,555.2 C243.38,555.2 243.39,555.24 243.39,555.24 C243.46,555.45 243.34,555.68 243.13,555.75 C242.91,555.82 242.68,555.7 242.61,555.48 C242.61,555.48 242.61,555.48 242.61,555.48 C242.61,555.48 242.56,555.32 242.46,555 C242.36,554.68 242.21,554.21 242.08,553.57 C241.8,552.32 241.56,550.43 241.64,548.05 C241.71,545.67 242.09,542.81 242.83,539.6 C243.55,536.39 244.63,532.84 245.98,529.03 C248.67,521.41 252.49,512.8 256.8,503.7 C261.11,494.59 265.92,484.98 270.49,475.27 C272.77,470.41 274.99,465.52 277.01,460.63 C279.02,455.75 280.84,450.87 282.18,446.02 C283.49,441.2 284.43,436.32 283.81,431.74 C283.17,427.17 282.02,422.95 280.44,419.24 C278.79,415.57 276.67,412.5 274.44,410.12 C272.22,407.72 269.88,406.02 267.83,404.88 C265.79,403.72 264.06,403.05 262.86,402.67 C261.66,402.3 260.99,402.19 260.99,402.19z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_19_P_0",
    fill: "#33857d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M288.17 527 C276.7,557.24 288.17,580.18 270.94,583.45 C263.06,584.95 259.58,579.11 258.14,572.32 C256.42,564.29 257.56,554.94 257.56,554.94 C257.56,554.94 260.48,547.47 266.62,540.21 C271.63,534.3 278.74,528.54 288.17,527z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_20_P_0",
    fill: "#bce5d6",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M248.17 564.48 C248.1,571.53 246.51,577.5 243.25,580.64 C242.93,580.96 242.6,581.24 242.3,581.47 C234.16,588.07 228.96,576 228.96,576 C228.96,576 207.31,565.32 196.57,543.64 C188.34,527 186.52,503.84 205.87,474.06 C208.71,495.27 220.33,509.7 231.84,523.41 C231.84,523.41 231.84,523.43 231.84,523.43 C233.28,525.15 234.7,526.82 236.12,528.52 C244.09,538.08 248.28,552.77 248.17,564.48z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_21_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M205.86 474.07 C205.86,474.07 205.45,475.77 204.99,478.79 C204.76,480.3 204.51,482.14 204.31,484.25 C204.11,486.37 203.94,488.77 203.89,491.38 C203.86,492.69 203.83,494.05 203.89,495.46 C203.9,496.17 203.92,496.89 203.94,497.61 C203.99,498.34 204.04,499.08 204.09,499.82 C204.27,502.82 204.71,505.95 205.31,509.16 C205.61,510.77 206.06,512.37 206.44,514.01 C206.97,515.6 207.42,517.24 208.04,518.84 C208.37,519.63 208.69,520.43 209.02,521.23 C209.02,521.23 209.52,522.42 209.52,522.42 C209.52,522.42 210.09,523.59 210.09,523.59 C210.84,525.16 211.7,526.66 212.6,528.16 C216.24,534.1 220.86,539.36 225.21,544.24 C227.39,546.69 229.49,549.06 231.38,551.41 C233.27,553.75 234.94,556.08 236.26,558.36 C237.59,560.64 238.58,562.88 239.22,564.94 C239.87,566.99 240.2,568.86 240.32,570.41 C240.41,571.18 240.43,571.87 240.43,572.47 C240.46,573.07 240.44,573.59 240.41,574 C240.37,574.83 240.34,575.27 240.34,575.27 C240.33,575.5 240.14,575.67 239.91,575.66 C239.69,575.65 239.52,575.45 239.53,575.23 C239.53,575.23 239.53,575.23 239.53,575.23 C239.53,575.23 239.53,575.2 239.53,575.2 C239.53,575.2 239.55,574.77 239.6,573.96 C239.64,573.56 239.65,573.06 239.63,572.48 C239.64,571.9 239.62,571.22 239.54,570.48 C239.43,568.98 239.13,567.16 238.51,565.16 C237.9,563.15 236.96,560.96 235.66,558.71 C234.38,556.45 232.75,554.14 230.89,551.8 C229.03,549.46 226.95,547.08 224.79,544.61 C220.48,539.7 215.87,534.38 212.25,528.37 C211.36,526.86 210.5,525.32 209.75,523.75 C209.75,523.75 209.19,522.57 209.19,522.57 C209.01,522.17 208.86,521.77 208.7,521.36 C208.37,520.56 208.05,519.76 207.73,518.96 C207.12,517.35 206.68,515.69 206.16,514.08 C205.79,512.44 205.35,510.82 205.06,509.21 C204.47,505.99 204.06,502.84 203.9,499.84 C203.85,499.09 203.81,498.35 203.76,497.62 C203.75,496.89 203.74,496.17 203.73,495.47 C203.69,494.05 203.72,492.69 203.76,491.38 C203.83,488.76 204.02,486.36 204.23,484.25 C204.45,482.13 204.71,480.29 204.95,478.78 C205.44,475.76 205.86,474.07 205.86,474.07z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_22_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M288.18 527 C288.18,527 287.54,527.69 286.48,528.96 C285.4,530.21 283.92,532.04 282.17,534.26 C281.31,535.39 280.36,536.59 279.41,537.9 C278.46,539.21 277.44,540.58 276.44,542.04 C275.42,543.49 274.41,545.01 273.41,546.57 C272.37,548.1 271.43,549.74 270.44,551.34 C269.47,552.95 268.59,554.62 267.67,556.23 C266.83,557.88 266.01,559.51 265.23,561.09 C264.53,562.71 263.82,564.26 263.21,565.75 C262.65,567.27 262.13,568.7 261.64,570.02 C261.26,571.37 260.9,572.61 260.59,573.71 C260.24,574.8 260.14,575.8 259.96,576.59 C259.66,578.2 259.48,579.12 259.48,579.12 C259.48,579.12 259.48,579.16 259.48,579.16 C259.43,579.38 259.22,579.53 259,579.49 C258.78,579.45 258.63,579.23 258.67,579.01 C258.67,579.01 258.67,579.01 258.67,579 C258.67,579 258.86,578.07 259.19,576.44 C259.39,575.63 259.5,574.62 259.87,573.52 C260.21,572.41 260.58,571.16 260.99,569.8 C261.5,568.47 262.05,567.04 262.63,565.51 C263.26,564.02 264,562.47 264.73,560.85 C265.53,559.27 266.38,557.64 267.25,556 C268.19,554.39 269.09,552.73 270.09,551.13 C271.1,549.54 272.07,547.91 273.13,546.38 C274.16,544.83 275.19,543.32 276.23,541.89 C277.25,540.44 278.28,539.08 279.26,537.79 C280.23,536.49 281.2,535.3 282.07,534.18 C283.85,531.98 285.36,530.17 286.45,528.93 C287.53,527.69 288.18,527 288.18,527z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_23_P_0",
    fill: "#bce5d6",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M281.21 579.82 C281.21,579.82 273.86,624.93 273.86,624.93 C273.5,626.82 271.84,628.2 269.91,628.2 C269.91,628.2 224.13,628.2 224.13,628.2 C222.2,628.2 220.54,626.82 220.18,624.93 C220.18,624.93 214.21,588.3 214.21,588.3 C214.21,588.3 212.83,579.82 212.83,579.82 C212.38,577.35 214.27,575.07 216.78,575.07 C216.78,575.07 277.26,575.07 277.26,575.07 C279.77,575.07 281.66,577.35 281.21,579.82z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_24_P_0",
    fill: "#86bda6",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M288.17 589.01 C288.17,589.01 205.87,589.01 205.87,589.01 C205.87,589.01 208.04,576.73 208.04,576.73 C208.51,574.15 210.75,572.26 213.37,572.26 C213.37,572.26 280.69,572.26 280.69,572.26 C283.29,572.26 285.55,574.15 286,576.73 C286,576.73 288.17,589.01 288.17,589.01z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_25_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M257.56 554.94 C257.56,554.94 256.42,564.25 258.12,572.26 C258.12,572.26 247.35,572.26 247.35,572.26 C247.87,569.92 248.13,567.28 248.17,564.48 C248.28,552.77 244.09,538.08 236.12,528.52 C234.7,526.82 233.28,525.15 231.84,523.43 C231.84,523.43 231.84,523.41 231.84,523.41 C232.01,516.81 233.52,508.91 237.3,499.63 C237.92,510.48 240.58,529.34 251.41,531.34 C259.64,532.84 270.36,524.68 278.52,516.77 C274.21,524.53 270.06,532.47 266.62,540.21 C260.48,547.47 257.56,554.94 257.56,554.94z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_26_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M251.46 628.2 C251.46,628.2 224.13,628.2 224.13,628.2 C222.2,628.2 220.54,626.82 220.18,624.93 C220.18,624.93 214.31,589.02 214.31,589.02 C214.31,589.02 237.92,589.02 237.92,589.02 C237.34,594.04 236.63,603.43 238.42,610.71 C239.81,616.49 244.88,623.92 251.46,628.2z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_27_P_0",
    fill: "#33857d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M837.35 722.25 C831.06,740.51 823.54,756.44 815.68,770.84 C788.5,820.48 756.95,852.06 755.77,898.35 C755.77,898.35 745.97,854.75 753.83,805.06 C758.24,777.15 768.2,747.34 788.59,722.25 C845.32,652.47 836.92,589.01 836.92,589.01 C836.92,589.01 865.37,641.06 837.35,722.25z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_28_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M771.16 843.92 C771.16,843.92 771.11,843.67 771.05,843.15 C770.98,842.64 770.9,841.88 770.82,840.89 C770.73,839.9 770.71,838.68 770.66,837.24 C770.68,835.81 770.62,834.15 770.76,832.31 C770.87,828.62 771.44,824.16 772.27,819.09 C772.52,817.84 772.79,816.54 773.06,815.2 C773.2,814.53 773.34,813.85 773.48,813.17 C773.66,812.49 773.84,811.8 774.02,811.1 C774.38,809.71 774.75,808.28 775.13,806.81 C775.56,805.36 776.04,803.9 776.52,802.39 C777.4,799.35 778.64,796.3 779.82,793.11 C780.39,791.5 781.13,789.93 781.82,788.32 C782.53,786.71 783.25,785.07 783.98,783.42 C784.79,781.8 785.61,780.16 786.44,778.5 C787.3,776.86 788.07,775.14 789.03,773.5 C789.97,771.85 790.93,770.18 791.89,768.5 C792.85,766.82 793.8,765.1 794.9,763.47 C799.11,756.79 803.79,750.13 807.69,742.86 C811.64,735.61 815.14,727.97 818.25,720.18 C824.46,704.59 829.16,688.41 832.58,673.04 C836,657.68 838.19,643.11 839.32,630.57 C840.42,618.02 840.49,607.48 839.67,600.17 C839.24,596.52 838.71,593.67 838.05,591.81 C837.8,590.86 837.44,590.18 837.24,589.72 C837.03,589.25 836.92,589.01 836.92,589.01 C836.92,589.01 837.03,589.25 837.24,589.72 C837.44,590.18 837.81,590.85 838.06,591.8 C838.73,593.66 839.28,596.52 839.72,600.16 C840.58,607.47 840.55,618.02 839.52,630.58 C838.44,643.14 836.32,657.73 832.97,673.13 C829.62,688.53 824.99,704.75 818.84,720.41 C815.76,728.24 812.28,735.92 808.35,743.21 C804.46,750.55 799.79,757.27 795.6,763.9 C794.49,765.53 793.56,767.24 792.6,768.91 C791.64,770.59 790.69,772.25 789.75,773.89 C788.79,775.52 788.03,777.23 787.17,778.87 C786.34,780.52 785.52,782.15 784.72,783.76 C783.99,785.41 783.28,787.04 782.58,788.64 C781.88,790.25 781.14,791.81 780.58,793.41 C779.41,796.58 778.17,799.62 777.29,802.64 C776.83,804.14 776.34,805.6 775.92,807.04 C775.54,808.49 775.17,809.92 774.81,811.3 C774.63,811.99 774.45,812.68 774.28,813.35 C774.14,814.03 774,814.71 773.86,815.37 C773.59,816.7 773.33,817.99 773.07,819.24 C772.25,824.27 771.69,828.69 771.57,832.35 C771.44,834.17 771.5,835.81 771.47,837.23 C771.53,838.64 771.55,839.85 771.64,840.82 C771.71,841.8 771.79,842.54 771.86,843.03 C771.92,843.52 771.97,843.79 771.97,843.79 C772.01,844.01 771.87,844.22 771.65,844.27 C771.43,844.32 771.21,844.17 771.17,843.95 C771.17,843.95 771.16,843.92 771.16,843.92z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_29_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M815.68 770.84 C788.51,820.48 756.95,852.06 755.77,898.35 C755.77,898.35 745.97,854.75 753.83,805.06 C771.45,797.86 796.22,786.13 815.68,770.84z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_30_P_0",
    fill: "#51b9a6",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M771.52 947.36 C771.52,947.36 751.68,913.43 798.64,871.57 C845.6,829.7 882.36,774.33 875.21,729.53 C830.29,781.72 710.84,855.72 744.53,947.36 C744.53,947.36 771.52,947.36 771.52,947.36z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_31_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M875.21 729.53 C875.21,729.53 874.83,730.47 873.98,732.18 C873.15,733.9 871.85,736.38 870.06,739.45 C869.16,740.99 868.16,742.69 867,744.49 C865.87,746.31 864.56,748.23 863.17,750.28 C861.78,752.33 860.19,754.44 858.56,756.7 C857.71,757.8 856.84,758.92 855.94,760.08 C855.05,761.23 854.14,762.42 853.15,763.58 C851.2,765.92 849.19,768.39 846.97,770.82 C845.87,772.04 844.77,773.3 843.62,774.55 C842.44,775.78 841.25,777.02 840.04,778.29 C835.21,783.35 829.82,788.39 824.12,793.46 C821.25,795.97 818.24,798.41 815.24,800.95 C813.73,802.21 812.22,803.47 810.7,804.75 C809.24,806.08 807.74,807.4 806.28,808.76 C800.47,814.26 794.99,820.28 789.95,826.66 C779.87,839.41 771.59,853.55 765.62,867.56 C759.64,881.56 756.02,895.45 754.71,907.55 C754.04,913.59 753.95,919.18 754.24,924.11 C754.34,926.58 754.67,928.86 754.91,930.99 C755.1,932.04 755.27,933.04 755.44,934.01 C755.53,934.49 755.61,934.96 755.7,935.42 C755.81,935.87 755.92,936.31 756.02,936.74 C756.23,937.6 756.43,938.41 756.62,939.18 C756.82,939.94 757.06,940.64 757.26,941.29 C757.67,942.6 758.01,943.72 758.39,944.59 C759.08,946.35 759.45,947.29 759.45,947.29 C759.45,947.29 759.46,947.32 759.46,947.32 C759.55,947.53 759.44,947.77 759.23,947.85 C759.02,947.93 758.79,947.83 758.7,947.62 C758.7,947.62 758.7,947.62 758.7,947.62 C758.7,947.62 758.33,946.66 757.63,944.88 C757.25,943.99 756.91,942.86 756.5,941.53 C756.3,940.86 756.05,940.16 755.85,939.38 C755.67,938.61 755.47,937.79 755.26,936.92 C755.16,936.48 755.05,936.03 754.94,935.57 C754.84,935.11 754.77,934.64 754.68,934.15 C754.51,933.18 754.34,932.16 754.15,931.1 C753.92,928.95 753.59,926.64 753.5,924.15 C753.22,919.18 753.33,913.55 754.02,907.47 C755.38,895.3 759.06,881.37 765.11,867.34 C771.14,853.3 779.49,839.15 789.63,826.41 C794.7,820.03 800.21,814.01 806.06,808.52 C807.52,807.15 809.03,805.84 810.5,804.51 C812.03,803.24 813.54,801.97 815.05,800.71 C818.06,798.19 821.07,795.76 823.95,793.26 C829.66,788.22 835.06,783.2 839.91,778.15 C841.12,776.9 842.31,775.65 843.49,774.43 C844.64,773.19 845.75,771.93 846.85,770.71 C849.08,768.29 851.09,765.84 853.05,763.5 C854.04,762.34 854.96,761.16 855.85,760.01 C856.75,758.86 857.63,757.73 858.48,756.64 C860.11,754.39 861.71,752.29 863.11,750.24 C864.5,748.19 865.82,746.28 866.95,744.46 C868.12,742.66 869.12,740.96 870.03,739.44 C871.83,736.36 873.14,733.89 873.97,732.18 C874.82,730.47 875.21,729.53 875.21,729.53z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_32_P_0",
    fill: "#33857d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M97.52 701.57 C97.52,701.57 73.02,679.24 60,623.41 C135.04,687.03 153.41,743.69 153.41,743.69 C153.41,743.69 97.52,701.57 97.52,701.57z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_33_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M60 623.41 C60,623.41 75.57,645.88 90.3,668.91 C92.13,671.8 93.99,674.67 95.75,677.53 C97.53,680.39 99.3,683.18 100.95,685.93 C102.61,688.67 104.23,691.31 105.7,693.86 C107.19,696.39 108.59,698.79 109.82,701.04 C111.08,703.27 112.23,705.32 113.17,707.19 C114.12,709.05 115.02,710.63 115.63,712 C116.9,714.72 117.62,716.28 117.62,716.28 C117.72,716.48 117.63,716.72 117.42,716.82 C117.22,716.91 116.97,716.83 116.88,716.62 C116.88,716.62 116.88,716.62 116.88,716.62 C116.88,716.62 116.87,716.6 116.87,716.6 C116.87,716.6 116.16,715.05 114.92,712.34 C114.33,710.97 113.44,709.39 112.51,707.53 C111.59,705.67 110.46,703.61 109.22,701.37 C108.01,699.12 106.62,696.71 105.15,694.18 C103.7,691.62 102.11,688.97 100.47,686.22 C98.84,683.46 97.09,680.65 95.34,677.78 C93.6,674.91 91.76,672.03 89.95,669.13 C75.4,645.99 60,623.41 60,623.41z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_34_P_0",
    fill: "#51b9a6",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M151.89 732.96 C138.39,720.81 118.42,708.76 99.41,695.78 C74.12,678.53 50.55,659.58 46.19,636.45 C36.27,719.95 133.39,757.54 133.39,757.54 C133.39,757.54 133.58,757.82 133.58,757.82 C133.58,757.82 168.86,809.27 168.86,809.27 C168.86,809.27 183.27,761.3 151.89,732.96z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_35_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M46.2 636.45 C46.2,636.45 46.15,637.32 46.24,638.95 C46.35,640.57 46.54,642.96 47.12,645.95 C47.35,647.46 47.8,649.09 48.22,650.87 C48.75,652.63 49.25,654.55 50.02,656.53 C50.68,658.55 51.63,660.59 52.57,662.78 C53.08,663.85 53.67,664.92 54.23,666.03 C54.52,666.59 54.8,667.15 55.11,667.71 C55.44,668.26 55.78,668.81 56.12,669.37 C58.71,673.9 62.2,678.38 66.19,682.82 C67.23,683.89 68.28,684.98 69.35,686.08 C69.87,686.64 70.45,687.15 71.03,687.66 C71.61,688.18 72.19,688.7 72.78,689.22 C75.1,691.33 77.59,693.36 80.23,695.27 C85.46,699.16 91.12,702.83 96.88,706.54 C102.64,710.25 108.51,714 114.25,717.94 C120,721.87 125.61,726.02 130.86,730.43 C136.12,734.84 141.01,739.53 145.32,744.45 C149.64,749.37 153.36,754.51 156.43,759.68 C159.47,764.86 161.78,770.06 163.58,774.98 C164,776.22 164.41,777.44 164.81,778.62 C165.21,779.81 165.48,781.01 165.81,782.16 C166.49,784.45 166.9,786.68 167.34,788.76 C167.45,789.28 167.55,789.8 167.66,790.3 C167.73,790.81 167.81,791.31 167.88,791.8 C168.02,792.79 168.16,793.74 168.29,794.65 C168.6,796.46 168.68,798.16 168.83,799.68 C169.15,802.72 169.14,805.12 169.2,806.76 C169.24,808.4 169.27,809.27 169.27,809.27 C169.27,809.5 169.1,809.68 168.87,809.69 C168.64,809.7 168.46,809.52 168.45,809.29 C168.45,809.29 168.45,809.29 168.45,809.29 C168.45,809.29 168.45,809.27 168.45,809.27 C168.45,809.27 168.43,808.4 168.39,806.78 C168.34,805.15 168.36,802.76 168.05,799.74 C167.91,798.23 167.84,796.55 167.54,794.75 C167.41,793.84 167.27,792.9 167.14,791.92 C167.07,791.43 166.99,790.94 166.92,790.43 C166.82,789.93 166.71,789.42 166.61,788.9 C166.18,786.83 165.79,784.62 165.12,782.34 C164.79,781.2 164.53,780.01 164.14,778.83 C163.75,777.65 163.34,776.44 162.93,775.21 C161.16,770.33 158.88,765.15 155.88,759.99 C152.86,754.85 149.18,749.73 144.9,744.82 C140.63,739.91 135.77,735.22 130.55,730.8 C125.33,726.39 119.74,722.22 114.02,718.28 C108.3,714.32 102.44,710.55 96.7,706.82 C90.95,703.08 85.3,699.39 80.07,695.48 C77.43,693.55 74.95,691.51 72.63,689.38 C72.05,688.86 71.46,688.34 70.88,687.82 C70.3,687.31 69.72,686.8 69.21,686.22 C68.14,685.12 67.09,684.02 66.05,682.94 C62.07,678.49 58.59,673.98 56.01,669.43 C55.67,668.87 55.33,668.32 55,667.77 C54.7,667.21 54.42,666.64 54.13,666.09 C53.57,664.97 52.99,663.89 52.48,662.82 C51.55,660.63 50.6,658.58 49.95,656.56 C49.18,654.57 48.69,652.65 48.17,650.89 C47.75,649.1 47.31,647.47 47.09,645.96 C46.51,642.97 46.34,640.57 46.24,638.95 C46.15,637.32 46.2,636.45 46.2,636.45z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_15_G_D_36_P_0",
    fill: "#f6eacd",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M843.3 984.62 C843.3,984.62 190.79,984.62 190.79,984.62 C180.5,984.62 172.16,976.28 172.16,965.99 C172.16,955.7 180.5,947.36 190.79,947.36 C190.79,947.36 843.3,947.36 843.3,947.36 C853.59,947.36 861.94,955.7 861.94,965.99 C861.94,976.28 853.59,984.62 843.3,984.62z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_14_G",
    transform: " translate(568, 612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_14_G_D_0_P_0",
    fill: "#fb9d82",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M582.56 621.62 C577.75,628.33 569.13,638.55 562.04,637.52 C561.78,637.48 561.51,637.44 561.16,637.37 C547.63,634.99 468.04,615.03 464.28,614.28 C460.45,613.53 433.67,613.27 435.19,610.45 C436.72,607.64 452.03,598.72 456.11,598.94 C460.2,599.15 476.29,603.82 492.35,603.3 C508.44,602.81 550.55,603.3 550.55,603.3 C550.55,603.3 552.59,599.78 552.59,599.78 C552.59,599.78 555.6,594.58 555.6,594.58 C554.76,610.17 573.56,622.89 582.56,621.62z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_13_G",
    transform: " translate(388, 934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_13_G_D_0_P_0",
    fill: "#fcbb17",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M412.98 910.6 C412.98,910.6 405.42,930.54 398.86,941.08 C396.27,945.29 393.79,948.02 392.05,947.36 C385.93,945.06 324.41,892.75 330.29,888.92 C331.15,888.37 332.53,887.98 334.25,887.77 C339.6,887.08 348.47,887.83 356.67,888.67 C363.72,889.4 370.27,890.19 373.69,890.19 C382.37,890.19 383.51,887.64 383.51,887.64 C383.7,888.64 385.33,890.56 387.76,892.88 C395.36,900.1 410.66,911.18 412.98,910.6z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_13_G_D_1_P_0",
    fill: "#1a1d66",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M387.76 892.88 C374.72,901.51 361.12,896.31 358.43,894.34 C356.46,892.9 356.46,890.21 356.67,888.67 C363.72,889.4 370.27,890.19 373.69,890.19 C382.37,890.19 383.5,887.64 383.5,887.64 C383.7,888.65 385.33,890.56 387.76,892.88z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_13_G_D_2_P_0",
    fill: "#1a1d66",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M398.86 941.08 C396.27,945.29 393.79,948.02 392.05,947.36 C385.93,945.06 324.41,892.75 330.29,888.92 C331.15,888.37 332.53,887.98 334.25,887.76 C334.25,887.76 398.86,941.08 398.86,941.08z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_12_G"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_R_G_L_12_C_0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_12_G_G_0_D_0_P_0",
    fill: "#fcbb17",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M235.6 257.11 C235.6,257.11 134.61,257.11 134.61,257.11 C131.07,257.11 128.19,254.23 128.19,250.69 C128.19,247.15 131.07,244.27 134.61,244.27 C134.61,244.27 235.6,244.27 235.6,244.27 C239.14,244.27 242.01,247.15 242.01,250.69 C242.01,254.23 239.14,257.11 235.6,257.11z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_12_G_G_0_D_1_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M197.47 285 C197.47,285 134.61,285 134.61,285 C131.07,285 128.2,282.13 128.2,278.58 C128.2,275.04 131.07,272.17 134.61,272.17 C134.61,272.17 197.47,272.17 197.47,272.17 C201.02,272.17 203.89,275.04 203.89,278.58 C203.89,282.13 201.02,285 197.47,285z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_12_G_G_0_D_2_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M197.47 314.94 C197.47,314.94 134.61,314.94 134.61,314.94 C131.07,314.94 128.2,312.07 128.2,308.53 C128.2,304.98 131.07,302.11 134.61,302.11 C134.61,302.11 197.47,302.11 197.47,302.11 C201.02,302.11 203.89,304.98 203.89,308.53 C203.89,312.07 201.02,314.94 197.47,314.94z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_11_G"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_R_G_L_11_C_0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_11_G_G_0_D_0_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M924.94 363.72 C924.94,363.72 730.53,363.72 730.53,363.72 C726.98,363.72 724.11,360.85 724.11,357.3 C724.11,353.76 726.98,350.89 730.53,350.89 C730.53,350.89 924.94,350.89 924.94,350.89 C928.49,350.89 931.36,353.76 931.36,357.3 C931.36,360.85 928.49,363.72 924.94,363.72z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_11_G_G_0_D_1_P_0",
    fill: "#fcbb17",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M855.52 392.61 C855.52,392.61 730.53,392.61 730.53,392.61 C726.98,392.61 724.11,389.74 724.11,386.19 C724.11,382.65 726.98,379.78 730.53,379.78 C730.53,379.78 855.52,379.78 855.52,379.78 C859.06,379.78 861.94,382.65 861.94,386.19 C861.94,389.74 859.06,392.61 855.52,392.61z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_11_G_G_0_D_2_P_0",
    fill: "#fcbb17",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M855.52 422.56 C855.52,422.56 730.53,422.56 730.53,422.56 C726.98,422.56 724.11,419.68 724.11,416.14 C724.11,412.6 726.98,409.72 730.53,409.72 C730.53,409.72 855.52,409.72 855.52,409.72 C859.06,409.72 861.94,412.6 861.94,416.14 C861.94,419.68 859.06,422.56 855.52,422.56z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_10_G",
    transform: " translate(343.305, 327.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_10_G_D_0_P_0",
    fill: "#fcbb17",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M401.84 381.7 C401.84,381.7 284.77,381.7 284.77,381.7 C278.99,381.7 274.3,377.01 274.3,371.23 C274.3,371.23 274.3,284.16 274.3,284.16 C274.3,278.38 278.99,273.7 284.77,273.7 C284.77,273.7 401.84,273.7 401.84,273.7 C407.62,273.7 412.31,278.38 412.31,284.16 C412.31,284.16 412.31,371.23 412.31,371.23 C412.31,377.01 407.62,381.7 401.84,381.7z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_9_G",
    transform: " translate(343.305, 327.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_9_G_D_0_P_0",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M373.26 321.39 C373.26,321.39 368.92,321.39 368.92,321.39 C368.26,319.02 367.28,316.77 366,314.72 C366,314.72 369.34,311.38 369.34,311.38 C370.62,310.1 370.62,308.04 369.34,306.76 C369.34,306.76 364.64,302.06 364.64,302.06 C363.36,300.78 361.3,300.78 360.02,302.06 C360.02,302.06 356.47,305.61 356.47,305.61 C354.5,304.51 352.4,303.64 350.18,303.08 C350.18,303.08 350.18,297.75 350.18,297.75 C350.18,295.95 348.71,294.48 346.91,294.48 C346.91,294.48 340.26,294.48 340.26,294.48 C338.46,294.48 336.99,295.95 336.99,297.75 C336.99,297.75 336.99,303.14 336.99,303.14 C334.84,303.69 332.79,304.51 330.89,305.56 C330.89,305.56 326.99,301.66 326.99,301.66 C325.71,300.39 323.65,300.39 322.37,301.66 C322.37,301.66 317.67,306.37 317.67,306.37 C316.39,307.64 316.39,309.71 317.67,310.98 C317.67,310.98 321.28,314.6 321.28,314.6 C320.07,316.52 319.12,318.61 318.44,320.83 C318.44,320.83 313.36,320.83 313.36,320.83 C311.55,320.83 310.09,322.29 310.09,324.09 C310.09,324.09 310.09,330.75 310.09,330.75 C310.09,332.55 311.55,334.01 313.36,334.01 C313.36,334.01 317.81,334.01 317.81,334.01 C318.31,336.47 319.15,338.81 320.31,340.98 C320.31,340.98 317.27,344.02 317.27,344.02 C316,345.29 316,347.36 317.27,348.63 C317.27,348.63 321.98,353.34 321.98,353.34 C323.25,354.61 325.32,354.61 326.59,353.34 C326.59,353.34 329.23,350.7 329.23,350.7 C331.44,352.13 333.86,353.24 336.44,353.96 C336.44,353.96 336.44,357.65 336.44,357.65 C336.44,359.45 337.9,360.91 339.7,360.91 C339.7,360.91 346.35,360.91 346.35,360.91 C348.16,360.91 349.62,359.45 349.62,357.65 C349.62,357.65 349.62,354.2 349.62,354.2 C352.28,353.58 354.8,352.56 357.08,351.19 C357.08,351.19 359.63,353.73 359.63,353.73 C360.9,355.01 362.97,355.01 364.24,353.73 C364.24,353.73 368.95,349.03 368.95,349.03 C370.22,347.76 370.22,345.69 368.95,344.41 C368.95,344.41 366.34,341.8 366.34,341.8 C367.63,339.58 368.6,337.15 369.2,334.57 C369.2,334.57 373.26,334.57 373.26,334.57 C375.06,334.57 376.52,333.11 376.52,331.31 C376.52,331.31 376.52,324.65 376.52,324.65 C376.52,322.85 375.06,321.39 373.26,321.39z  M346.86 345.05 C335.04,347.29 324.89,337.13 327.12,325.32 C328.37,318.71 333.7,313.39 340.3,312.14 C352.12,309.9 362.27,320.06 360.04,331.88 C358.79,338.48 353.47,343.8 346.86,345.05z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_8_G",
    transform: " translate(392, 526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_8_G_D_0_P_0",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M683.78 342.79 C683.78,342.79 393.3,342.79 393.3,342.79 C393.3,342.79 393.3,333.87 393.3,333.87 C393.3,331.47 395.25,329.52 397.65,329.52 C397.65,329.52 679.43,329.52 679.43,329.52 C681.83,329.52 683.78,331.47 683.78,333.87 C683.78,333.87 683.78,342.79 683.78,342.79z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_8_G_D_1_P_0",
    fill: "#1c0f58",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M675.67 497.66 C675.67,497.66 401.41,497.66 401.41,497.66 C396.93,497.66 393.3,494.03 393.3,489.55 C393.3,489.55 393.3,342.79 393.3,342.79 C393.3,342.79 683.78,342.79 683.78,342.79 C683.78,342.79 683.78,489.55 683.78,489.55 C683.78,494.03 680.15,497.66 675.67,497.66z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_8_G_D_2_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M669.84 336.15 C669.84,337.28 668.93,338.2 667.8,338.2 C666.67,338.2 665.76,337.28 665.76,336.15 C665.76,335.03 666.67,334.11 667.8,334.11 C668.93,334.11 669.84,335.03 669.84,336.15z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_8_G_D_3_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M655.8 336.15 C655.8,337.28 654.89,338.2 653.76,338.2 C652.63,338.2 651.72,337.28 651.72,336.15 C651.72,335.03 652.63,334.11 653.76,334.11 C654.89,334.11 655.8,335.03 655.8,336.15z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_8_G_D_4_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M641.77 336.15 C641.77,337.28 640.85,338.2 639.72,338.2 C638.6,338.2 637.68,337.28 637.68,336.15 C637.68,335.03 638.6,334.11 639.72,334.11 C640.85,334.11 641.77,335.03 641.77,336.15z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_8_G_D_5_P_0",
    fill: "#1c0f58",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M393.3 481.98 C393.3,481.98 393.3,533.09 393.3,533.09 C393.3,533.09 440.26,486.12 440.26,486.12 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_7_G"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_R_G_L_7_C_0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_7_G_G_0_D_0_P_0",
    fill: "#fcbb17",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M569.66 363.72 C569.66,363.72 408.36,363.72 408.36,363.72 C406.81,363.72 405.55,362.46 405.55,360.91 C405.55,359.36 406.81,358.1 408.36,358.1 C408.36,358.1 569.66,358.1 569.66,358.1 C571.21,358.1 572.47,359.36 572.47,360.91 C572.47,362.46 571.21,363.72 569.66,363.72z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_7_G_G_0_D_1_P_0",
    fill: "#fcbb17",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M569.66 381.58 C569.66,381.58 408.36,381.58 408.36,381.58 C406.81,381.58 405.55,380.33 405.55,378.78 C405.55,377.23 406.81,375.97 408.36,375.97 C408.36,375.97 569.66,375.97 569.66,375.97 C571.21,375.97 572.47,377.23 572.47,378.78 C572.47,380.33 571.21,381.58 569.66,381.58z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_7_G_G_0_D_2_P_0",
    fill: "#fcbb17",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M492.71 399.45 C492.71,399.45 408.36,399.45 408.36,399.45 C406.81,399.45 405.55,398.19 405.55,396.64 C405.55,395.09 406.81,393.84 408.36,393.84 C408.36,393.84 492.71,393.84 492.71,393.84 C494.26,393.84 495.52,395.09 495.52,396.64 C495.52,398.19 494.26,399.45 492.71,399.45z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_7_G_G_0_D_3_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M569.66 435.18 C569.66,435.18 408.36,435.18 408.36,435.18 C406.81,435.18 405.55,433.93 405.55,432.38 C405.55,430.83 406.81,429.57 408.36,429.57 C408.36,429.57 569.66,429.57 569.66,429.57 C571.21,429.57 572.47,430.83 572.47,432.38 C572.47,433.93 571.21,435.18 569.66,435.18z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_7_G_G_0_D_4_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M492.71 453.05 C492.71,453.05 408.36,453.05 408.36,453.05 C406.81,453.05 405.55,451.79 405.55,450.24 C405.55,448.69 406.81,447.44 408.36,447.44 C408.36,447.44 492.71,447.44 492.71,447.44 C494.26,447.44 495.52,448.69 495.52,450.24 C495.52,451.79 494.26,453.05 492.71,453.05z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_7_G_G_0_D_5_P_0",
    fill: "#fcbb17",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M492.71 470.92 C492.71,470.92 408.36,470.92 408.36,470.92 C406.81,470.92 405.55,469.66 405.55,468.11 C405.55,466.56 406.81,465.3 408.36,465.3 C408.36,465.3 492.71,465.3 492.71,465.3 C494.26,465.3 495.52,466.56 495.52,468.11 C495.52,469.66 494.26,470.92 492.71,470.92z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_7_G_G_0_D_6_P_0",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M569.66 399.45 C569.66,399.45 509.05,399.45 509.05,399.45 C507.5,399.45 506.24,398.19 506.24,396.64 C506.24,395.09 507.5,393.84 509.05,393.84 C509.05,393.84 569.66,393.84 569.66,393.84 C571.21,393.84 572.47,395.09 572.47,396.64 C572.47,398.19 571.21,399.45 569.66,399.45z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_7_G_G_0_D_7_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M649.73 359.33 C649.73,359.33 606.87,402.19 606.87,402.19 C605.77,403.29 604,403.29 602.9,402.19 C601.8,401.1 601.8,399.32 602.9,398.22 C602.9,398.22 645.76,355.36 645.76,355.36 C646.86,354.26 648.64,354.26 649.73,355.36 C650.83,356.46 650.83,358.23 649.73,359.33z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_7_G_G_0_D_8_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M651.59 440.42 C651.59,454.37 640.28,465.69 626.32,465.69 C612.36,465.69 601.04,454.37 601.04,440.42 C601.04,426.46 612.36,415.14 626.32,415.14 C640.28,415.14 651.59,426.46 651.59,440.42z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_7_G_G_0_D_9_P_0",
    fill: "#51b9a6",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M623.01 458.03 C623.01,465.93 616.6,472.34 608.7,472.34 C600.8,472.34 594.39,465.93 594.39,458.03 C594.39,450.13 600.8,443.72 608.7,443.72 C616.6,443.72 623.01,450.13 623.01,458.03z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_6_G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_0_P_0",
    fill: "#1c0f58",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M568.44 759 C568.44,759 482.97,825.55 469.41,842.46 C464.3,848.86 455.38,860.08 446.15,871.57 C430.98,890.45 414.89,910.13 412.98,910.6 C409.93,911.37 384.28,891.85 383.5,887.64 C383.03,885.02 406.38,844.93 426.6,812.71 C438.91,793.12 450.03,776.4 453.94,772.79 C464.28,763.21 527.86,729.53 527.86,729.53 C527.86,729.53 568.44,759 568.44,759z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_1_P_0",
    stroke: "#070606",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.818,
    strokeOpacity: 1,
    d: " M405.33 896.4 C405.33,896.4 485.18,782.74 525.27,763.59 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_2_P_0",
    fill: "#323232",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M657.53 467.15 C656.63,469.21 655.6,471.36 654.44,473.55 C648.18,485.49 652.8,497.46 645.67,500.51 C645.24,500.68 644.77,500.85 644.23,500.96 C635.04,503 613.86,490.76 612.93,484.63 C612.01,478.51 619.46,468.03 612.93,466.76 C606.4,465.49 602.88,476.47 602.88,476.47 C597.51,477.03 595.6,468.03 586.79,468.03 C585.54,468.03 584.32,468.2 583.14,468.5 C578.99,469.53 575.36,472.09 573.04,474.06 C571.32,475.5 570.33,476.64 570.33,476.64 C570.33,476.64 562.49,471.68 562.86,461.91 C563.48,446.42 569.2,435.12 582.97,432.82 C584.49,415.59 598.67,406.4 617.62,405.82 C634.22,405.3 636.71,420.23 637.1,423.95 C636.95,421.18 636.18,412.07 632.22,405.82 C640.54,405.45 647.86,411.38 645.95,430.71 C647.86,424.96 654.56,421.33 659.72,425.54 C654.95,425.54 650.35,433.57 650.35,433.57 C650.35,433.57 655.96,437.16 659.79,443.8 C662.96,449.27 661.76,457.37 657.53,467.15z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_3_P_0",
    fill: "#fb9d82",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M645.67 500.51 C645.67,500.51 645.46,503.34 645.46,503.34 C645.46,503.34 644.73,513.4 644.73,513.4 C644.73,513.4 629.43,526.48 620.75,513.4 C620.69,513.31 620.64,513.23 620.56,513.14 C617.87,509.14 615.45,507.75 613.23,507.49 C608.44,506.91 604.58,511.59 600.58,506.52 C589.15,492.02 584.6,475.22 583.14,468.5 C584.32,468.2 585.54,468.03 586.79,468.03 C595.6,468.03 597.51,477.03 602.88,476.47 C602.88,476.47 606.4,465.49 612.93,466.76 C619.46,468.03 612.01,478.51 612.93,484.63 C613.34,487.36 617.79,491.31 623.42,494.67 C629.97,498.6 638.13,501.71 643.31,501.11 C643.63,501.07 643.93,501.02 644.23,500.96 C644.77,500.85 645.24,500.68 645.67,500.51z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_4_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M648.05 519.22 C641.16,523.92 628.53,524.7 628.53,524.7 C628.53,524.7 618.19,523.17 618.19,523.17 C618.19,523.17 613.88,516.9 615.9,513.4 C616.28,512.71 617.25,511.77 618.63,510.65 C621.4,508.37 625.86,505.45 630.48,503.04 C635.25,500.57 640.17,498.62 643.72,498.4 C652.39,497.91 654.95,514.49 648.05,519.22z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_5_P_0",
    fill: "#ffd56a",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M646.02 686.78 C630.63,689.74 598.09,680.68 582.51,673.68 C577.92,671.61 574.78,669.72 574.03,668.39 C571.04,663.13 574.05,659.09 581.46,642.38 C582.3,640.49 583.18,638.45 584.13,636.23 C589.15,624.4 589.17,599.15 589.15,577.39 C589.09,558.77 589,542.7 591.97,539.84 C598.39,533.66 630.44,513.4 630.44,513.4 C630.44,513.4 636.82,546.65 636.82,546.65 C636.82,546.65 640.43,563.54 644.23,585.58 C651.23,626.16 658.93,684.29 646.02,686.78z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_6_P_0",
    fill: "#1c0f58",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M656.73 701.58 C656.73,703.11 641.42,738.83 628.57,743.94 C615.73,749.05 538.3,743.43 538.3,743.43 C538.3,743.43 500.02,768.45 500.02,768.45 C500.02,768.45 508.04,843.85 508.04,843.85 C508.04,843.85 513.62,896.4 513.62,896.4 C513.62,896.4 513.79,898.1 513.79,898.1 C502.09,905.74 472.59,907.81 469.41,901.21 C469.39,901.19 469.39,901.17 469.39,901.17 C466.32,894.53 419.36,753.14 437.75,728.63 C456.11,704.14 574.03,668.39 574.03,668.39 C577.1,670.34 580.67,672.11 584.55,673.67 C597.66,679.04 614.31,682.42 626.98,684.39 C631.86,685.15 636.13,685.7 639.4,686.09 C643.52,686.58 646.02,686.78 646.02,686.78 C646.02,686.78 656.73,700.03 656.73,701.58z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_7_P_0",
    fill: "#fcbb17",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M518.65 947.35 C518.65,947.35 419.1,947.35 419.1,947.35 C418.61,945.59 419.27,943.81 420.78,942.01 C424.82,937.15 434.93,932.27 444.69,928.06 C453.94,924.07 462.84,920.63 465.82,918.27 C472.85,912.7 469.61,901.88 469.41,901.21 C470.49,903.42 474.55,904.67 479.92,905.04 C490.46,905.79 506.04,903.17 513.79,898.1 C513.79,898.1 513.62,896.4 513.62,896.4 C516.59,902.07 517.98,930.1 518.46,942.01 C518.58,945.29 518.65,947.35 518.65,947.35z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_8_P_0",
    fill: "#1a1d66",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M479.92 905.04 C479.62,909.78 478.93,917.47 477.55,919.54 C475.51,922.61 453.56,933.33 450.51,932.3 C448.53,931.65 446.12,929.5 444.68,928.07 C453.94,924.07 462.84,920.63 465.82,918.27 C472.85,912.71 469.6,901.88 469.41,901.21 C470.49,903.43 474.55,904.67 479.92,905.04z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_9_P_0",
    fill: "#1a1d66",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M518.65 947.36 C518.65,947.36 419.1,947.36 419.1,947.36 C418.61,945.59 419.27,943.81 420.78,942.01 C420.78,942.01 518.46,942.01 518.46,942.01 C518.58,945.29 518.65,947.36 518.65,947.36z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_10_P_0",
    stroke: "#070606",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.818,
    strokeOpacity: 1,
    d: " M582.56 679.75 C582.56,679.75 578.89,699.28 593.18,705.79 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_11_P_0",
    stroke: "#070606",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.818,
    strokeOpacity: 1,
    d: " M575.06 695.45 C575.06,695.45 480.51,735.78 475.97,748.28 C471.43,760.79 500.02,896.4 500.02,896.4 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_12_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M656.73 701.58 C656.73,703.1 641.42,738.83 628.57,743.94 C615.73,749.05 538.3,743.43 538.3,743.43 C538.3,743.43 500.02,768.45 500.02,768.45 C500.02,768.45 508.04,843.85 508.04,843.85 C508.04,843.85 491.86,757.73 491.86,752.1 C491.86,747.29 598.8,716.55 626.98,684.39 C638.02,686.13 646.02,686.78 646.02,686.78 C646.02,686.78 656.73,700.03 656.73,701.58z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_13_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M606.32 610.2 C599.68,619.61 588.98,631.55 581.46,642.38 C582.3,640.49 583.18,638.45 584.12,636.23 C589.15,624.4 589.17,599.15 589.15,577.39 C589.15,577.39 612.07,562.23 612.07,562.23 C612.07,562.23 617.04,595.01 606.32,610.2z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_14_P_0",
    fill: "#fcbb17",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M586.75 618.72 C585.76,619.63 584.75,620.53 583.74,621.37 C583.37,621.49 582.99,621.58 582.56,621.62 C573.56,622.89 554.76,610.17 555.6,594.58 C555.66,593.42 556.58,591.1 558.09,588.07 C565.78,572.56 588.92,538.04 593.17,539.63 C593.17,539.63 608.03,541.93 612.07,562.23 C615.85,581.28 602.21,604.39 586.75,618.72z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_15_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M639.4 686.09 C636.13,685.7 631.86,685.15 626.98,684.39 C614.31,682.42 597.66,679.05 584.55,673.67 C596.11,673.27 620.84,665.66 623.82,609.06 C625.18,619.65 627.22,630.63 630.05,641.86 C633.86,656.79 637.44,672.54 639.4,686.09z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_16_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M633.3 499.37 C632.12,500.74 631.19,501.99 630.48,503.04 C625.86,505.45 621.4,508.37 618.63,510.65 C616.69,508.52 614.91,507.68 613.23,507.49 C613.23,507.49 623.42,494.66 623.42,494.66 C626.51,496.53 629.97,498.19 633.3,499.37z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_17_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M582.56 621.62 C577.74,628.33 569.13,638.55 562.04,637.52 C561.78,637.48 561.5,637.44 561.16,637.37 C552.4,624.7 552.07,608.09 552.59,599.78 C552.59,599.78 555.6,594.58 555.6,594.58 C554.76,610.17 573.55,622.89 582.56,621.62z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_6_G_D_18_P_0",
    fill: "#323232",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M657.53 467.15 C656.63,469.21 655.59,471.36 654.43,473.55 C651.36,479.41 650.93,485.26 650.42,490.09 C649.39,489.3 648.33,488.56 647.28,487.94 C640.64,491.89 636.17,496 633.3,499.37 C633.3,499.37 633.28,499.39 633.28,499.39 C623.91,496.04 613.58,488.87 612.93,484.63 C612.01,478.51 619.46,468.03 612.93,466.76 C606.4,465.49 602.88,476.47 602.88,476.47 C597.51,477.03 595.6,468.03 586.79,468.03 C585.54,468.03 584.32,468.2 583.14,468.5 C578.99,469.53 575.36,472.09 573.04,474.06 C573.04,474.06 582.96,460.12 598.54,462.94 C598.54,462.94 596.26,458.6 585.78,459.11 C607.73,451.96 621.76,454.77 628.53,462.68 C634.05,469.15 647,477.14 657.53,467.15z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_5_G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_5_G_D_0_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M649.58 716.38 C645.5,729.14 620,726.86 616.91,736.3 C610.34,756.32 606.7,747.51 581.46,750.07 C567.03,751.53 556.54,760.78 550.23,768.45 C550.23,768.45 500.02,768.45 500.02,768.45 C500.02,768.45 505.24,764.74 505.24,764.74 C505.24,764.74 538.3,743.43 538.3,743.43 C538.3,743.43 604.66,738.83 604.66,738.83 C608.23,724.03 617.94,723.54 632.74,721.99 C641.35,721.11 642.19,706.56 639.57,687.34 C637.66,673.5 633.96,657.24 630.05,641.86 C627.22,630.63 625.18,619.65 623.82,609.06 C622.21,596.66 621.5,584.83 621.44,573.68 C631.26,624.85 652.61,706.93 649.58,716.38z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_5_G_D_1_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M686.34 630.11 C686.34,628.56 686.34,627.04 686.31,625.51 C685.69,545 668.48,500.59 647.28,487.94 C653.92,484.01 662.75,480.25 674.41,477.65 C670.91,482.7 667.26,490.28 668.98,498.38 C672.05,512.71 706.77,567.83 693.49,656.15 C683.91,719.86 687.09,753.01 697.1,768.45 C697.1,768.45 625.59,768.45 625.59,768.45 C625.59,768.45 686.34,750.58 686.34,630.11z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_4_G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_4_G_D_0_P_0",
    fill: "#b99966",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M702.17 768.45 C702.17,768.45 625.59,768.45 625.59,768.45 C625.59,768.45 686.34,750.58 686.34,630.11 C686.34,628.56 686.34,627.04 686.31,625.51 C685.69,545 668.48,500.6 647.28,487.94 C653.92,484.01 662.75,480.25 674.41,477.65 C679.51,476.49 685.11,475.57 691.32,474.92 C743.76,469.58 785.65,490.13 790.63,513.4 C795.59,536.66 764.94,768.45 702.17,768.45z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_4_G_D_1_P_0",
    fill: "#998058",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M686.34 630.11 C686.34,750.58 625.58,768.45 625.58,768.45 C625.58,768.45 500.02,768.45 500.02,768.45 C500.02,768.45 505.24,764.74 505.24,764.74 C505.24,764.74 538.3,743.43 538.3,743.43 C538.3,743.43 604.66,738.83 604.66,738.83 C608.23,724.03 617.94,723.53 632.74,721.99 C641.35,721.11 642.19,706.56 639.57,687.34 C637.66,673.5 633.96,657.24 630.05,641.86 C627.22,630.62 625.18,619.65 623.82,609.06 C622.21,596.66 621.5,584.83 621.44,573.68 C621.25,548.28 624.34,526.59 627.6,510.91 C627.91,509.38 628.23,507.92 628.55,506.52 C628.55,506.48 628.57,506.42 628.57,506.37 C628.87,505.71 630.18,503 633.28,499.39 C633.28,499.39 633.3,499.37 633.3,499.37 C636.18,496 640.64,491.89 647.28,487.94 C648.33,488.56 649.39,489.29 650.42,490.09 C670.16,505.13 685.71,549.01 686.31,625.51 C686.34,627.04 686.34,628.56 686.34,630.11z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_4_G_D_2_P_0",
    fill: "#514f4a",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M662.1 947.36 C662.1,947.36 571.71,947.36 571.71,947.36 C568.61,947.36 567.26,943.45 569.71,941.53 C569.71,941.53 592.33,923.83 592.33,923.83 C602.36,915.97 608.23,903.92 608.23,891.18 C608.23,891.18 608.23,768.45 608.23,768.45 C608.23,768.45 625.58,768.45 625.58,768.45 C625.58,768.45 625.58,891.18 625.58,891.18 C625.58,903.92 631.45,915.97 641.5,923.83 C641.5,923.83 664.1,941.53 664.1,941.53 C666.55,943.45 665.2,947.36 662.1,947.36z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_4_G_D_3_P_0",
    stroke: "#070606",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.818,
    strokeOpacity: 1,
    d: " M731.05 479.55 C731.05,479.55 731.3,480.19 731.74,481.47 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_4_G_D_4_P_0",
    stroke: "#070606",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 0.818,
    strokeOpacity: 1,
    d: " M684.49 763.82 C683.99,764.28 683.48,764.74 682.97,765.19 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_4_G_D_5_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M625.58 768.45 C625.58,768.45 625.58,801.97 625.58,801.97 C619.57,805.1 613.47,807.51 608.23,809.27 C608.23,809.27 608.23,768.45 608.23,768.45 C608.23,768.45 625.58,768.45 625.58,768.45z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_4_G_D_6_P_0",
    fill: "#070606",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M649.58 716.38 C645.5,729.14 620,726.86 616.91,736.3 C610.34,756.32 606.7,747.51 581.46,750.07 C567.03,751.53 556.54,760.78 550.23,768.45 C550.23,768.45 500.02,768.45 500.02,768.45 C500.02,768.45 505.24,764.74 505.24,764.74 C505.24,764.74 538.3,743.43 538.3,743.43 C538.3,743.43 604.66,738.83 604.66,738.83 C608.23,724.03 617.94,723.54 632.74,721.99 C641.35,721.11 642.19,706.56 639.57,687.34 C637.66,673.5 633.96,657.24 630.05,641.86 C627.22,630.63 625.18,619.65 623.82,609.06 C622.21,596.66 621.5,584.83 621.44,573.68 C631.26,624.85 652.61,706.93 649.58,716.38z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_4_G_D_7_P_0",
    fill: "#594a33",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M686.34 630.11 C686.34,628.56 686.34,627.04 686.31,625.51 C685.69,545 668.48,500.59 647.28,487.94 C653.92,484.01 662.75,480.25 674.41,477.65 C670.91,482.7 667.26,490.28 668.98,498.38 C672.05,512.71 706.77,567.83 693.49,656.15 C683.91,719.86 687.09,753.01 697.1,768.45 C697.1,768.45 625.59,768.45 625.59,768.45 C625.59,768.45 686.34,750.58 686.34,630.11z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_3_G",
    transform: " translate(650.444, 274.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_3_G_D_0_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M665.54 243.98 C653.06,237.77 638.06,240.22 628.21,250.07 C616.04,262.24 615.63,281.75 626.92,294.45 C626.92,294.45 622.06,293.87 622.06,293.87 C621.47,293.8 620.93,294.22 620.86,294.81 C620.79,295.4 621.21,295.93 621.8,296 C621.8,296 629.21,296.88 629.21,296.88 C629.51,296.92 629.79,296.83 630,296.66 C630.22,296.49 630.37,296.24 630.41,295.94 C630.41,295.94 631.26,288.78 631.26,288.78 C631.33,288.19 630.91,287.65 630.32,287.58 C629.73,287.51 629.19,287.93 629.13,288.52 C629.13,288.52 628.58,293.09 628.58,293.09 C617.98,281.23 618.34,262.98 629.73,251.59 C638.93,242.39 652.93,240.1 664.58,245.9 C665.11,246.16 665.75,245.94 666.02,245.41 C666.28,244.88 666.07,244.24 665.54,243.98z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_3_G_D_1_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M637.65 303.42 C650.12,309.63 665.12,307.18 674.98,297.32 C687.15,285.15 687.55,265.65 676.26,252.95 C676.26,252.95 681.13,253.53 681.13,253.53 C681.72,253.59 682.25,253.17 682.32,252.59 C682.39,252 681.97,251.46 681.38,251.39 C681.38,251.39 673.97,250.51 673.97,250.51 C673.68,250.48 673.4,250.56 673.18,250.73 C672.97,250.9 672.81,251.16 672.78,251.45 C672.78,251.45 671.93,258.62 671.93,258.62 C671.86,259.21 672.28,259.74 672.87,259.81 C673.46,259.88 673.99,259.46 674.06,258.87 C674.06,258.87 674.6,254.31 674.6,254.31 C685.2,266.16 684.84,284.42 673.46,295.8 C664.26,305 650.25,307.29 638.61,301.5 C638.08,301.23 637.43,301.45 637.17,301.98 C636.9,302.51 637.12,303.15 637.65,303.42z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_2_G",
    transform: " translate(500, 500)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_2_G_D_0_P_0",
    fill: "#1c0f58",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M458.47 256.61 C458.47,256.61 341.39,256.61 341.39,256.61 C335.61,256.61 330.92,251.93 330.92,246.14 C330.92,246.14 330.92,159.08 330.92,159.08 C330.92,153.3 335.61,148.61 341.39,148.61 C341.39,148.61 458.47,148.61 458.47,148.61 C464.25,148.61 468.93,153.3 468.93,159.08 C468.93,159.08 468.93,246.14 468.93,246.14 C468.93,251.93 464.25,256.61 458.47,256.61z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_2_G_D_1_P_0",
    fill: "#fcbb17",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M363.06 186.81 C363.06,186.81 363.06,198.43 363.06,198.43 C363.06,199.37 363.81,200.12 364.74,200.12 C364.74,200.12 371.18,200.12 371.18,200.12 C372.11,200.12 372.86,199.37 372.86,198.43 C372.86,198.43 372.86,186.81 372.86,186.81 C372.86,185.88 373.62,185.12 374.55,185.12 C374.55,185.12 375.17,185.12 375.17,185.12 C376.1,185.12 376.86,185.88 376.86,186.81 C376.86,186.81 376.86,218.41 376.86,218.41 C376.86,219.34 376.1,220.1 375.17,220.1 C375.17,220.1 374.55,220.1 374.55,220.1 C373.62,220.1 372.86,219.34 372.86,218.41 C372.86,218.41 372.86,205.44 372.86,205.44 C372.86,204.51 372.11,203.75 371.18,203.75 C371.18,203.75 364.74,203.75 364.74,203.75 C363.81,203.75 363.06,204.51 363.06,205.44 C363.06,205.44 363.06,218.41 363.06,218.41 C363.06,219.34 362.3,220.1 361.37,220.1 C361.37,220.1 360.75,220.1 360.75,220.1 C359.81,220.1 359.06,219.34 359.06,218.41 C359.06,218.41 359.06,186.81 359.06,186.81 C359.06,185.88 359.81,185.12 360.75,185.12 C360.75,185.12 361.37,185.12 361.37,185.12 C362.3,185.12 363.06,185.88 363.06,186.81z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_2_G_D_2_P_0",
    fill: "#fcbb17",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M385.49 188.7 C385.49,188.7 382.48,188.7 382.48,188.7 C381.55,188.7 380.79,187.95 380.79,187.02 C380.79,187.02 380.79,186.81 380.79,186.81 C380.79,185.88 381.55,185.12 382.48,185.12 C382.48,185.12 395.87,185.12 395.87,185.12 C396.8,185.12 397.55,185.88 397.55,186.81 C397.55,186.81 397.55,187.02 397.55,187.02 C397.55,187.95 396.8,188.7 395.87,188.7 C395.87,188.7 392.86,188.7 392.86,188.7 C391.93,188.7 391.17,189.46 391.17,190.39 C391.17,190.39 391.17,218.41 391.17,218.41 C391.17,219.34 390.42,220.1 389.48,220.1 C389.48,220.1 388.86,220.1 388.86,220.1 C387.93,220.1 387.17,219.34 387.17,218.41 C387.17,218.41 387.17,190.39 387.17,190.39 C387.17,189.46 386.42,188.7 385.49,188.7z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_2_G_D_3_P_0",
    fill: "#fcbb17",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M422.4 205.05 C422.14,200.43 421.88,195.29 422.04,191.35 C422.04,191.35 421.83,191.35 421.83,191.35 C421.05,195.24 420.12,199.39 419.03,203.49 C419.03,203.49 414.72,219.89 414.72,219.89 C414.72,219.89 412.18,219.89 412.18,219.89 C412.18,219.89 408.08,204.17 408.08,204.17 C406.94,199.7 405.9,195.4 405.23,191.35 C405.23,191.35 405.07,191.35 405.07,191.35 C405.07,195.45 404.86,200.33 404.66,205.31 C404.66,205.31 404.05,218.49 404.05,218.49 C404.01,219.39 403.27,220.1 402.37,220.1 C402.37,220.1 402.19,220.1 402.19,220.1 C401.22,220.1 400.45,219.28 400.51,218.31 C400.51,218.31 402.38,186.71 402.38,186.71 C402.43,185.82 403.17,185.12 404.06,185.12 C404.06,185.12 405.47,185.12 405.47,185.12 C406.24,185.12 406.92,185.65 407.11,186.39 C407.11,186.39 410.88,201.11 410.88,201.11 C412.08,205.72 412.96,209.15 413.68,213.14 C413.68,213.14 413.84,213.14 413.84,213.14 C414.51,209.15 415.29,205.83 416.43,201.11 C416.43,201.11 420.06,186.41 420.06,186.41 C420.25,185.65 420.92,185.12 421.7,185.12 C421.7,185.12 423.25,185.12 423.25,185.12 C424.14,185.12 424.88,185.82 424.93,186.71 C424.93,186.71 426.76,218.31 426.76,218.31 C426.81,219.28 426.04,220.1 425.07,220.1 C425.07,220.1 424.73,220.1 424.73,220.1 C423.83,220.1 423.09,219.39 423.05,218.49 C423.05,218.49 422.4,205.05 422.4,205.05z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_2_G_D_4_P_0",
    fill: "#fcbb17",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M433.99 185.12 C433.99,185.12 434.61,185.12 434.61,185.12 C435.54,185.12 436.3,185.88 436.3,186.81 C436.3,186.81 436.3,215.04 436.3,215.04 C436.3,215.97 437.05,216.72 437.98,216.72 C437.98,216.72 444.47,216.72 444.47,216.72 C445.4,216.72 446.15,217.48 446.15,218.41 C446.15,219.34 445.4,220.1 444.47,220.1 C444.47,220.1 433.99,220.1 433.99,220.1 C433.06,220.1 432.3,219.34 432.3,218.41 C432.3,218.41 432.3,186.81 432.3,186.81 C432.3,185.88 433.06,185.12 433.99,185.12z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_1_G",
    transform: " translate(536, 450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_1_G_D_0_P_0",
    fill: "#1c0f58",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M511.84 157.86 C516.22,157.86 517.25,154.91 517.25,152.29 C517.25,149.98 517.01,147.75 516.78,145.52 C516.54,143.13 516.3,140.98 516.3,138.51 C516.3,131.34 520.68,128.31 526.33,128.31 C526.33,128.31 527.29,128.31 527.29,128.31 C527.29,128.31 527.29,132.45 527.29,132.45 C527.29,132.45 526.09,132.45 526.09,132.45 C522.75,132.45 521.39,134.84 521.39,138.43 C521.39,140.58 521.63,142.57 521.87,144.48 C522.03,146.55 522.27,148.46 522.27,150.37 C522.35,156.59 520.2,158.74 516.78,159.69 C516.78,159.69 516.78,159.85 516.78,159.85 C520.2,160.89 522.35,163.04 522.27,169.33 C522.27,171.32 522.03,173.31 521.87,175.31 C521.63,177.3 521.39,179.29 521.39,181.44 C521.39,185.02 522.59,187.49 526.17,187.49 C526.17,187.49 527.29,187.49 527.29,187.49 C527.29,187.49 527.29,191.63 527.29,191.63 C527.29,191.63 526.25,191.63 526.25,191.63 C521,191.63 516.3,189.01 516.3,181.44 C516.3,179.05 516.54,176.66 516.78,174.35 C517.01,172.04 517.25,169.73 517.25,167.5 C517.25,164.95 516.22,161.84 511.84,161.84 C511.84,161.84 511.84,157.86 511.84,157.86z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_1_G_D_1_P_0",
    fill: "#1c0f58",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M593.04 161.84 C588.66,161.84 587.62,164.95 587.62,167.5 C587.62,169.73 587.86,172.04 588.1,174.35 C588.33,176.66 588.57,179.05 588.57,181.44 C588.57,189.01 583.88,191.63 578.62,191.63 C578.62,191.63 577.58,191.63 577.58,191.63 C577.58,191.63 577.58,187.49 577.58,187.49 C577.58,187.49 578.7,187.49 578.7,187.49 C582.28,187.09 583.48,185.02 583.48,181.44 C583.48,179.29 583.24,177.3 583.08,175.31 C582.84,173.31 582.6,171.32 582.6,169.33 C582.52,163.04 584.67,160.89 588.1,159.85 C588.1,159.85 588.1,159.69 588.1,159.69 C584.67,158.74 582.52,156.59 582.6,150.37 C582.6,148.46 582.84,146.55 583.08,144.48 C583.24,142.57 583.48,140.58 583.48,138.43 C583.48,134.84 582.12,132.85 578.78,132.45 C578.78,132.45 577.58,132.45 577.58,132.45 C577.58,132.45 577.58,128.31 577.58,128.31 C577.58,128.31 578.54,128.31 578.54,128.31 C584.19,128.31 588.57,131.34 588.57,138.51 C588.57,140.98 588.33,143.13 588.1,145.52 C587.86,147.75 587.62,149.98 587.62,152.29 C587.62,154.91 588.66,157.86 593.04,157.86 C593.04,157.86 593.04,161.84 593.04,161.84z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_1_G_D_2_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M565.71 167.63 C565.71,167.63 565.71,152.31 565.71,152.31 C565.71,152.31 552.44,144.65 552.44,144.65 C552.44,144.65 539.17,152.31 539.17,152.31 C539.17,152.31 539.17,167.63 539.17,167.63 C539.17,167.63 552.44,175.29 552.44,175.29 C552.44,175.29 565.71,167.63 565.71,167.63z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_0_G",
    transform: " translate(500, 466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_0_P_0",
    fill: "#fe3e0d",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M578.1 322.04 C578.1,322.04 461.03,322.04 461.03,322.04 C455.25,322.04 450.56,317.35 450.56,311.57 C450.56,311.57 450.56,224.5 450.56,224.5 C450.56,218.72 455.25,214.03 461.03,214.03 C461.03,214.03 578.1,214.03 578.1,214.03 C583.88,214.03 588.57,218.72 588.57,224.5 C588.57,224.5 588.57,311.57 588.57,311.57 C588.57,317.35 583.88,322.04 578.1,322.04z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_1_P_0",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M496.26 286.19 C495.44,286.19 494.61,285.85 493.98,285.18 C493.98,285.18 479.44,269.61 479.44,269.61 C478.18,268.26 478.18,266.08 479.44,264.73 C479.44,264.73 494.23,248.91 494.23,248.91 C495.49,247.56 497.53,247.56 498.79,248.91 C500.04,250.25 500.04,252.44 498.79,253.78 C498.79,253.78 486.27,267.17 486.27,267.17 C486.27,267.17 498.54,280.3 498.54,280.3 C499.8,281.65 499.8,283.83 498.54,285.18 C497.91,285.85 497.09,286.19 496.26,286.19z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_2_P_0",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M542.86 286.19 C542.04,286.19 541.21,285.85 540.58,285.18 C539.33,283.83 539.33,281.65 540.58,280.3 C540.58,280.3 552.85,267.17 552.85,267.17 C552.85,267.17 540.34,253.78 540.34,253.78 C539.08,252.44 539.08,250.25 540.34,248.91 C541.6,247.56 543.64,247.56 544.9,248.91 C544.9,248.91 559.69,264.73 559.69,264.73 C560.29,265.38 560.63,266.26 560.63,267.17 C560.63,268.09 560.29,268.96 559.69,269.61 C559.69,269.61 545.14,285.18 545.14,285.18 C544.51,285.85 543.69,286.19 542.86,286.19z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_D_3_P_0",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M512.34 290.47 C511.94,290.47 511.53,290.38 511.13,290.21 C509.48,289.49 508.69,287.48 509.36,285.72 C509.36,285.72 523.8,247.76 523.8,247.76 C524.47,246 526.34,245.14 528,245.86 C529.65,246.58 530.44,248.59 529.77,250.36 C529.77,250.36 515.33,288.32 515.33,288.32 C514.82,289.65 513.61,290.47 512.34,290.47z "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "time_group"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodingAnimation);
export default __webpack_public_path__ + "static/media/coding_animation.a8f8e09a950d548e8c620a1890a40787.svg";
export { ForwardRef as ReactComponent };